<!-- /****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
-->

<div class="supp-manage-group">
  <div mat-dialog-title>{{title}}</div>
  @if (!(allGroups && allGroups.length)) {
    <div mat-dialog-content style="padding:20px;">
      {{'supplier.userlist.managegroup.noGroupsFound' | translate}}
    </div>
  }
  <div style="display: flex; flex-direction: row">
    <label for="myGroups" class="mat-subheading-2" style="margin-right: 10px; flex: 1 1 20%; max-width: 20%; box-sizing: border-box">{{'supplier.userlist.managegroup.myGroups'
    | translate}} :</label>
    @if (allGroups && allGroups.length) {
      <ng-multiselect-dropdown style="min-width:30%" [settings]="dropdownSettings" [data]="allGroups" [(ngModel)]="myGroups"
        [ngModelOptions]="{standalone: true}">
      </ng-multiselect-dropdown>
    }
  </div>
  <div style="margin-top:100px; display: flex; flex-direction: row; gap: 10px">
    <div style="flex: 1 1 50%; max-width: 50%; box-sizing: border-box"></div>
    <div style="justify-content: flex-end; gap: 10px; flex: 1 1 50%; max-width: 50%; box-sizing: border-box" mat-dialog-actions class="wrap-break event-buttons">
      <button mat-raised-button cdkFocusInitial color="primary" type="submit" (click)="updateGroups()">
        {{'supplier.userlist.managerole.submit' |translate }}
      </button>
    </div>
  </div>
</div>

